import React, { useState } from "react";
import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { toastError, toastSuccess } from "../../helpers";
import { useTranslation } from "react-i18next";
import { useSaveNftTransferRecordMutation } from "../../app/features/apiSlice";

const TransferNFT = ({ nft, identitySession, refetch }) => {
  const { t } = useTranslation();
  const [transactionId, setTransactionId] = useState();
  const [tradeData, setTradeData] = useState({
    asset_id: nft.asset_id,
    actorName: "",
    to: "",
    memo: "GT Token Transfer",
  });
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [saveNftTransferRecord, { isLoading }] =
    useSaveNftTransferRecordMutation();
  const signTransaction = async () => {
    if (!tradeData.to || !tradeData.memo) {
      toastError("", t("enterRecipientAccountNameAndMemo"));
      return;
    }
    try {
      const action = {
        authorization: [
          {
            actor: String(identitySession.auth.actor),
            permission: String(identitySession.auth.permission),
          },
        ],
        account: process.env.REACT_APP_EXC_NFT_ACCOUNT,
        name: "transfer",
        data: {
          from: String(identitySession.auth.actor),
          to: tradeData.to,
          asset_ids: [tradeData.asset_id],
          memo: tradeData.memo,
        },
      };

      // !Call transact on the session (compatible with eosjs.transact)
      const response = await identitySession.transact(
        { actions: [action] },
        // { broadcast: true } // true is only working with EOS token
      );

      // !Update application state with the responses of the transaction
      if (response?.processed?.id) {
        setTransactionId(response?.processed);
      }
      const result = await saveNftTransferRecord({
        response: response?.processed,
        assetId: tradeData.asset_id,
      });
      if (result?.error) {
        toastError(result, t("error.serverNotResponding"));
      } else {
        toastSuccess(t("nftTransferSuccess"));
        setShow(false);
        refetch();
      }
    } catch (error) {
      toastError("", error.message);
      identitySession?.link?.transport?.closeModal?.();
    }
  };

  return (
    <>
      <Button variant="secondary" onClick={handleShow}>
        {t("transfer")}
      </Button>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="text-dark h6">
            {t("transferGTToken")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Label>
            {t("assetID")}: {tradeData.asset_id}
          </Form.Label>
          <br />
          <Form.Label>{t("enterRecipientAccountName")}</Form.Label>
          <Form.Control
            type="text"
            value={tradeData.to}
            onChange={(e) => setTradeData({ ...tradeData, to: e.target.value })}
            size="sm"
            className="mb-2"
          />
          <Form.Label>{t("enterMemo")}</Form.Label>
          <Form.Control
            type="text"
            onChange={(e) =>
              setTradeData({ ...tradeData, memo: e.target.value })
            }
            placeholder={t("enterMemo")}
            size="sm"
            className="mb-2"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("close")}
          </Button>
          <Button
            type="button"
            variant="gold"
            onClick={signTransaction}
            disabled={transactionId && !isLoading ? true : false}
          >
            {t("signTransaction")}
            {isLoading && (
              <Spinner animation="border" size="sm" className="ms-2" />
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TransferNFT;
